module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1e.a9019d2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-3-1e.svg
// module id = 572
// module chunks = 0